(function () {
    "use strict";

    function SelectText(element) {
        var doc = document,
            text = element,
            range,
            selection;
        if (doc.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }

    var iconsWrapper = document.getElementById("icons-wrapper"),
        listItems = iconsWrapper ? iconsWrapper.getElementsByTagName("li") : "";
    if (listItems) {
        for (var i = 0; i < listItems.length; i++) {
            listItems[i].onclick = function fun(event) {
                var selectedTagName = event.target.tagName.toLowerCase();
                if (selectedTagName == "p" || selectedTagName == "em") {
                    SelectText(event.target);
                } else if (selectedTagName == "input") {
                    event.target.setSelectionRange(
                        0,
                        event.target.value.length
                    );
                }
            };

            var beforeContentChar = window
                    .getComputedStyle(
                        listItems[i].getElementsByTagName("i")[0],
                        "::before"
                    )
                    .getPropertyValue("content")
                    .replace(/'/g, "")
                    .replace(/"/g, ""),
                beforeContent = beforeContentChar.codePointAt(0).toString(16);
            var beforeContentElement = document.createElement("em");
            beforeContentElement.textContent = "\\" + beforeContent;
            listItems[i].appendChild(beforeContentElement);

            //create input element to copy/paste chart
            var charCharac = document.createElement("input");
            charCharac.setAttribute("type", "text");
            charCharac.setAttribute("maxlength", "1");
            charCharac.setAttribute("readonly", "true");
            charCharac.setAttribute("value", beforeContentChar);
            listItems[i].appendChild(charCharac);
        }
    }
})();
